/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_Status_FinalizedInputs */

const es_co2_error_report_status_finalized = /** @type {(inputs: Error_Report_Status_FinalizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este reporte ya está finalizado.`)
};

/**

* @param {Error_Report_Status_FinalizedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_report_status_finalized = /** @type {((inputs?: Error_Report_Status_FinalizedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_Status_FinalizedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_report_status_finalized(inputs)
});